import React from 'react';
import ConceptBau from './concept_bau';

// conceptName = 'bau'
const App = ({ conceptName }) => {
  switch (conceptName) {
    case 'bau': return (<ConceptBau />);
    default: return null;
  }
};

export default App;
